import { AssetsExtItem } from "@/models/Hardware/AssetsExtItem"

/// <summary>
/// ハードウェア一覧（詳細）
/// ※メンバ変数の頭文字は小文字にしておくこと（キャメルケース）
/// </summary>

// ネットワーク情報
// ★値を追加したら、AssetsDataUtil.MargeAssetsData()も更新すること
export class NICItem {
    nicName = "";
    networkCategory = "";
    mac = "";
    ipAllocateType = "";
    ip = "";
    subnetMask = "";
    defGateway = "";
    defGatewayMAC = "";
    dns = "";
    globalAddr = "";
    uniqueLocalAddr = "";
    temporaryAddr = "";
    linkLocalAddr = "";
    iPv6DefGateway = "";
    iPv6DefGatewayMAC = "";
    iPv6DNS = "";
    globalAddrAllocateType = "";
    uniqueLocalAddrAllocateType = "";
    temporaryAddrAllocateType = "";
    linkLocalAddrAllocateType = "";
}

// ドライブ情報
// ★値を追加したら、AssetsDataUtil.MargeAssetsData()も更新すること
export class DriveItem {
    driveType = "";
    driveName = "";
    storage = "";
    freeStorage = "";
    encryptState = "";
    encryptType = "";
}

// ディスプレイ情報
// ★値を追加したら、AssetsDataUtil.MargeAssetsData()も更新すること
export class DisplayItem {
    dspAdptName = "";
    resolution = "";
    bitsPerPel = "";
    dspAdptMfg = "";
    dspAdptDrvName = "";
    dspAdptDrvDesc = "";
    dspAdptDrvFile = "";
    dspAdptDevID = "";
    monitorName = "";
    monitorSerial = "";
    monitorMfg = "";
    monitorDrvName = "";
    monitorDrvDesc = "";
    monitorDrvFile = "";
    monitorDevID = "";
}

// プリンター情報
// ★値を追加したら、AssetsDataUtil.MargeAssetsData()も更新すること
export class PrinterItem {
    printerName = "";
    driverName = "";
    portName = "";
    ipAddress = "";
}

// モデム情報
// ★値を追加したら、AssetsDataUtil.MargeAssetsData()も更新すること
export class ModemItem {
    modemName = "";
}

// SCSI情報
// ★値を追加したら、AssetsDataUtil.MargeAssetsData()も更新すること
export class SCSIItem {
    scsiName = "";
}

// 資産情報データ
// ※メンバ変数の頭文字は小文字にしておくこと（キャメルケース）
// ★値を追加したら、AssetsDataUtil.MargeAssetsData()も更新すること
export class AssetsData {
    // 左ペイン
    agentID = "";
    agentName = "";
    divisionName = "";
    osName = "";
    spName = "";
    osBuildVersion = "";
    serviceOptionID = "";
    computerName = "";
    domain = "";
    logonUser = "";
    logonUserName = "";
    logonUserDomain = "";
    machineVendor = "";
    machineName = "";
    machineSerial = "";
    memory = "";
    scvVersion = "";
    agentType = "";
    appliedTime = "";
    applyStatus = "";
    lastBootup = "";
    lastBootupTime = "";

    // 右ペイン
    // 基本項目
    assetNo = "";
    conditionclassID = "";
    netBiosName = "";
    nicCount = "";
    nicItems = new Array<NICItem>();
    driveCount = "";
    driveItems = new Array<DriveItem>();
    displayCount = "";
    displayItems = new Array<DisplayItem>();
    scrSaverStatus = "";
    defPrinter = "";
    printerItems = new Array<PrinterItem>();
    setupType = "";
    buyDate = "";
    expire = "";
    managersDivision = "";
    manager = "";
    usersDivision = "";
    email = "";
    place = "";
    memo = "";
    setupper = "";
    previousManager = "";
    previousUser = "";
    registerDate = "";
    setupDate = "";
    buyFrom = "";
    price = "";
    cost = "";

    // ソフトウェア
    osProductID = "";
    systemLanguage = "";
    japaneseLanguagePackStatus = "";
    osLicenseTypeID = "";
    osLicensingModelID = "";
    edgeVersion = ""
    firefoxVersion = "";
    chromeVersion =  "";
    safariVersion =  "";
    ieName = "";
    spNameIE = "";

    // モバイル情報
    subscriberCarrierNetwork = "";
    phoneNumber = "";
    capacity = "";
    passcodePresent = "";
    isSupervised = "";
    imei = "";
    mdmProfileInstalled = "";
    mdmProfileUninstalled = "";
    skyseaMdmInstalled = "";
    skyseaMdmLastBootup = "";
    skyseaMdmVersion = "";
    skyseaMdmProfileStatus = "";
    deviceName = "";
    model = "";
    carrierSettingsVersion = "";
    iccid = "";
    meid = "";
    modemFirmwareVersion = "";
    currentCarrierNetwork = "";
    callularTechnology = "";
    subscriberMCC = "";
    subscriberMNC = "";
    currentMCC = "";
    currentMNC = "";
    personalHotspotEnabled = "";
    isRoaming = "";
    dataRoamingEnabled = "";
    voiceRoamingEnabled = "";
    batteryLevel = "";
    isCloudBackupEnabled = "";
    lastCloudBackupDate = "";
    passcodeCompliantWithProfile = "";
    passcodeLockGracePeriodEnforced = "";
    hardwareEncryptionCaps = "";
    isDeviceLocatorServiceEnabled = "";
    isMDMLostModeEnabled = "";
    isActivationLockEnabled = "";
    isDoNotDisturbInEffect = "";
    iTunesStoreAccountIsActive = "";
    iTunesStoreAccountHash = "";
    easDeviceIdentifier = "";
    certificateName = "";
    profileName = "";
    payloadDisplayName = "";
    status = "";
    androidEnterpriseStatus = "";
    policyAppliedDateTime = "";
    appliedLatestSettingProfile = "";
    followPolicyStatus = "";
    locationInfoLastUpdateDateTime = "";
    availableDeviceCapacity = "";

    // 任意項目
    assetsExtItems = new Array<AssetsExtItem>();

    // その他
    processorCount = "";
    processorCoreCount = "";
    cpuType = "";
    cpuClock = "";
    biosVersion = "";
    motherUUID = "";
    amtMode = "";
    amtState = "";
    amtVersion = "";
    amtFqdn = "";
    modemCount = "";
    modemItems = Array<ModemItem>();
    scsiCount = "";
    scsiItems = new Array<SCSIItem>();
    lastProxyURL = "";
    globalIPAddr = "";
    skyCPState = "";
    addinInfoEdge = "";
    addinInfoFirefox = "";
    addinInfoChrome = "";
    addinInfoSafari = "";
    agentPcTypeID = "";
    macDefaultMailer = "";
    macKext = "";
    jreVersion = "";
	mdmState = "";
	mdmAgentLastServerCommState = "";
	mdmAgentLastGetPositionState = "";
    consoleInstalled = "";
    receiverInstalled = "";
    consoleInstalled_Standard = "";
    receiverInstalled_Standard = "";

    // ハードウェア一覧に表示しない項目
    win10OSVersion = "";
    receiverAgentID = "";
    deviceNameEditInfo = "";
    divisionID = "";
}

// 資産情報データのユーティリティクラス
export class AssetsDataUtil {
    /**
     * 文字列を日付に変換します
     * @param[in] strDate : 文字列
     * @return  日付クラス（空白時はnullを返します。変換できなければnullを返します。）
     */
    public convertDate(strDate: string): Date | null {
        if ("" == strDate || null == strDate) {
            return null;
        }
        const dateReturn = new Date(strDate);

        return dateReturn;
    }

    /**
     * @brief	日付フォーマット(時刻なし)
     */
    public dateFormat(target: Date): string {
        const day: number = target.getDate();
        const month: number = target.getMonth() + 1;
        const year: number = target.getFullYear();
        return `${year}/${('00' + month).slice(-2)}/${('00' + day).slice(-2)}`;
    }

    /**
     * 「任意項目」のデータを50に補完する
     * @param[in/out] astData : 補完対象
     */
    public CompAssetsExtItems(astData: AssetsData): void {
        // 任意項目の数は50個固定。
        // 通常時は50個以外になることはないが、任意項目のタイトルは50個のため、データも50個に補完しておく。
        if (50 != astData.assetsExtItems.length) {
            // 以前の情報を記録
            const mapOld = new Map<number, string>();
            astData.assetsExtItems.forEach(x => mapOld.set(x.itemID, x.itemData));

            // 50個に統一する
            astData.assetsExtItems.length = 0;
            for (let i = 1; i <= 50; i++) {
                const item = new AssetsExtItem();
                item.agentID = Number(astData.agentID);
                item.itemID = i;
                const strData = mapOld.get(i);
                if (undefined == strData) {
                    item.itemData = "";
                }
                else {
                    item.itemData = strData;
                }
                astData.assetsExtItems.push(item);
            }
        }
    }

    /**
     * 複数編集時の資産情報をマージする
     * @param[in/out] dstAstData : 今までのマージ結果、マージ結果格納先
     * @param[in] srcAstData : マージ対象
     */
    public MargeAssetsData(dstAstData: AssetsData, srcAstData: AssetsData): void {
        if (dstAstData.agentID != srcAstData.agentID) {
            dstAstData.agentID = "";
        }

        if (dstAstData.agentName != srcAstData.agentName) {
            dstAstData.agentName = "";
        }

        if (dstAstData.divisionName != srcAstData.divisionName) {
            dstAstData.divisionName = "";
        }

        if (dstAstData.osName != srcAstData.osName) {
            dstAstData.osName = "";
        }

        if (dstAstData.spName != srcAstData.spName) {
            dstAstData.spName = "";
        }

        if (dstAstData.osBuildVersion != srcAstData.osBuildVersion) {
            dstAstData.osBuildVersion = "";
        }

        if (dstAstData.serviceOptionID != srcAstData.serviceOptionID) {
            dstAstData.serviceOptionID = "";
        }

        if (dstAstData.computerName != srcAstData.computerName) {
            dstAstData.computerName = "";
        }

        if (dstAstData.domain != srcAstData.domain) {
            dstAstData.domain = "";
        }

        if (dstAstData.logonUser != srcAstData.logonUser) {
            dstAstData.logonUser = "";
        }

        if (dstAstData.logonUserName != srcAstData.logonUserName) {
            dstAstData.logonUserName = "";
        }

        if (dstAstData.logonUserDomain != srcAstData.logonUserDomain) {
            dstAstData.logonUserDomain = "";
        }

        if (dstAstData.machineVendor != srcAstData.machineVendor) {
            dstAstData.machineVendor = "";
        }

        if (dstAstData.machineName != srcAstData.machineName) {
            dstAstData.machineName = "";
        }

        if (dstAstData.machineSerial != srcAstData.machineSerial) {
            dstAstData.machineSerial = "";
        }

        if (dstAstData.memory != srcAstData.memory) {
            dstAstData.memory = "";
        }

        if (dstAstData.scvVersion != srcAstData.scvVersion) {
            dstAstData.scvVersion = "";
        }

        if (dstAstData.agentType != srcAstData.agentType) {
            dstAstData.agentType = "";
        }

        if (dstAstData.appliedTime != srcAstData.appliedTime) {
            dstAstData.appliedTime = "";
        }

        if (dstAstData.applyStatus != srcAstData.applyStatus) {
            dstAstData.applyStatus = "";
        }

        if (dstAstData.lastBootup != srcAstData.lastBootup) {
            dstAstData.lastBootup = "";
        }

        if (dstAstData.lastBootupTime != srcAstData.lastBootupTime) {
            dstAstData.lastBootupTime = "";
        }

        if (dstAstData.assetNo != srcAstData.assetNo) {
            dstAstData.assetNo = "";
        }

        if (dstAstData.conditionclassID != srcAstData.conditionclassID) {
            dstAstData.conditionclassID = "";
        }

        if (dstAstData.netBiosName != srcAstData.netBiosName) {
            dstAstData.netBiosName = "";
        }

        if (dstAstData.nicCount != srcAstData.nicCount) {
            dstAstData.nicCount = "";
        }

        let i = 0;
        for (i = 0; i < dstAstData.nicItems.length; i++) {
            if (srcAstData.nicItems.length <= i) {
                dstAstData.nicItems[i] = new NICItem();
                continue;
            }

            if (dstAstData.nicItems[i].nicName != srcAstData.nicItems[i].nicName) {
                dstAstData.nicItems[i].nicName = "";
            }

            if (dstAstData.nicItems[i].networkCategory != srcAstData.nicItems[i].networkCategory) {
                dstAstData.nicItems[i].networkCategory = "";
            }

            if (dstAstData.nicItems[i].mac != srcAstData.nicItems[i].mac) {
                dstAstData.nicItems[i].mac = "";
            }

            if (dstAstData.nicItems[i].ipAllocateType != srcAstData.nicItems[i].ipAllocateType) {
                dstAstData.nicItems[i].ipAllocateType = "";
            }

            if (dstAstData.nicItems[i].ip != srcAstData.nicItems[i].ip) {
                dstAstData.nicItems[i].ip = "";
            }

            if (dstAstData.nicItems[i].subnetMask != srcAstData.nicItems[i].subnetMask) {
                dstAstData.nicItems[i].subnetMask = "";
            }

            if (dstAstData.nicItems[i].defGateway != srcAstData.nicItems[i].defGateway) {
                dstAstData.nicItems[i].defGateway = "";
            }

            if (dstAstData.nicItems[i].defGatewayMAC != srcAstData.nicItems[i].defGatewayMAC) {
                dstAstData.nicItems[i].defGatewayMAC = "";
            }

            if (dstAstData.nicItems[i].dns != srcAstData.nicItems[i].dns) {
                dstAstData.nicItems[i].dns = "";
            }

            if (dstAstData.nicItems[i].globalAddr != srcAstData.nicItems[i].globalAddr) {
                dstAstData.nicItems[i].globalAddr = "";
            }

            if (dstAstData.nicItems[i].uniqueLocalAddr != srcAstData.nicItems[i].uniqueLocalAddr) {
                dstAstData.nicItems[i].uniqueLocalAddr = "";
            }

            if (dstAstData.nicItems[i].temporaryAddr != srcAstData.nicItems[i].temporaryAddr) {
                dstAstData.nicItems[i].temporaryAddr = "";
            }

            if (dstAstData.nicItems[i].linkLocalAddr != srcAstData.nicItems[i].linkLocalAddr) {
                dstAstData.nicItems[i].linkLocalAddr = "";
            }

            if (dstAstData.nicItems[i].iPv6DefGateway != srcAstData.nicItems[i].iPv6DefGateway) {
                dstAstData.nicItems[i].iPv6DefGateway = "";
            }

            if (dstAstData.nicItems[i].iPv6DefGatewayMAC != srcAstData.nicItems[i].iPv6DefGatewayMAC) {
                dstAstData.nicItems[i].iPv6DefGatewayMAC = "";
            }

            if (dstAstData.nicItems[i].iPv6DNS != srcAstData.nicItems[i].iPv6DNS) {
                dstAstData.nicItems[i].iPv6DNS = "";
            }

            if (dstAstData.nicItems[i].globalAddrAllocateType != srcAstData.nicItems[i].globalAddrAllocateType) {
                dstAstData.nicItems[i].globalAddrAllocateType = "";
            }

            if (dstAstData.nicItems[i].uniqueLocalAddrAllocateType != srcAstData.nicItems[i].uniqueLocalAddrAllocateType) {
                dstAstData.nicItems[i].uniqueLocalAddrAllocateType = "";
            }

            if (dstAstData.nicItems[i].temporaryAddrAllocateType != srcAstData.nicItems[i].temporaryAddrAllocateType) {
                dstAstData.nicItems[i].temporaryAddrAllocateType = "";
            }

            if (dstAstData.nicItems[i].linkLocalAddrAllocateType != srcAstData.nicItems[i].linkLocalAddrAllocateType) {
                dstAstData.nicItems[i].linkLocalAddrAllocateType = "";
            }
        }

        if (dstAstData.driveCount != srcAstData.driveCount) {
            dstAstData.driveCount = "";
        }

        for (i = 0; i < dstAstData.driveItems.length; i++) {
            if (srcAstData.driveItems.length <= i) {
                dstAstData.driveItems[i] = new DriveItem();
                continue;
            }

            if (dstAstData.driveItems[i].driveType != srcAstData.driveItems[i].driveType) {
                dstAstData.driveItems[i].driveType = "";
            }

            if (dstAstData.driveItems[i].driveName != srcAstData.driveItems[i].driveName) {
                dstAstData.driveItems[i].driveName = "";
            }

            if (dstAstData.driveItems[i].storage != srcAstData.driveItems[i].storage) {
                dstAstData.driveItems[i].storage = "";
            }

            if (dstAstData.driveItems[i].freeStorage != srcAstData.driveItems[i].freeStorage) {
                dstAstData.driveItems[i].freeStorage = "";
            }

            if (dstAstData.driveItems[i].encryptState != srcAstData.driveItems[i].encryptState) {
                dstAstData.driveItems[i].encryptState = "";
            }

            if (dstAstData.driveItems[i].encryptType != srcAstData.driveItems[i].encryptType) {
                dstAstData.driveItems[i].encryptType = "";
            }
        }

        if (dstAstData.displayCount != srcAstData.displayCount) {
            dstAstData.displayCount = "";
        }

        for (i = 0; i < dstAstData.displayItems.length; i++) {
            if (srcAstData.displayItems.length <= i) {
                dstAstData.displayItems[i] = new DisplayItem();
                continue;
            }

            if (dstAstData.displayItems[i].dspAdptName != srcAstData.displayItems[i].dspAdptName) {
                dstAstData.displayItems[i].dspAdptName = "";
            }

            if (dstAstData.displayItems[i].resolution != srcAstData.displayItems[i].resolution) {
                dstAstData.displayItems[i].resolution = "";
            }

            if (dstAstData.displayItems[i].bitsPerPel != srcAstData.displayItems[i].bitsPerPel) {
                dstAstData.displayItems[i].bitsPerPel = "";
            }

            if (dstAstData.displayItems[i].dspAdptMfg != srcAstData.displayItems[i].dspAdptMfg) {
                dstAstData.displayItems[i].dspAdptMfg = "";
            }

            if (dstAstData.displayItems[i].dspAdptDrvName != srcAstData.displayItems[i].dspAdptDrvName) {
                dstAstData.displayItems[i].dspAdptDrvName = "";
            }

            if (dstAstData.displayItems[i].dspAdptDrvDesc != srcAstData.displayItems[i].dspAdptDrvDesc) {
                dstAstData.displayItems[i].dspAdptDrvDesc = "";
            }

            if (dstAstData.displayItems[i].dspAdptDrvFile != srcAstData.displayItems[i].dspAdptDrvFile) {
                dstAstData.displayItems[i].dspAdptDrvFile = "";
            }

            if (dstAstData.displayItems[i].dspAdptDevID != srcAstData.displayItems[i].dspAdptDevID) {
                dstAstData.displayItems[i].dspAdptDevID = "";
            }

            if (dstAstData.displayItems[i].monitorName != srcAstData.displayItems[i].monitorName) {
                dstAstData.displayItems[i].monitorName = "";
            }

            if (dstAstData.displayItems[i].monitorSerial != srcAstData.displayItems[i].monitorSerial) {
                dstAstData.displayItems[i].monitorSerial = "";
            }

            if (dstAstData.displayItems[i].monitorMfg != srcAstData.displayItems[i].monitorMfg) {
                dstAstData.displayItems[i].monitorMfg = "";
            }

            if (dstAstData.displayItems[i].monitorDrvName != srcAstData.displayItems[i].monitorDrvName) {
                dstAstData.displayItems[i].monitorDrvName = "";
            }

            if (dstAstData.displayItems[i].monitorDrvDesc != srcAstData.displayItems[i].monitorDrvDesc) {
                dstAstData.displayItems[i].monitorDrvDesc = "";
            }

            if (dstAstData.displayItems[i].monitorDrvFile != srcAstData.displayItems[i].monitorDrvFile) {
                dstAstData.displayItems[i].monitorDrvFile = "";
            }

            if (dstAstData.displayItems[i].monitorDevID != srcAstData.displayItems[i].monitorDevID) {
                dstAstData.displayItems[i].monitorDevID = "";
            }
        }

        for (i = 0; i < dstAstData.printerItems.length; i++) {
            if (srcAstData.printerItems.length <= i) {
                dstAstData.printerItems[i] = new PrinterItem();
                continue;
            }

            if (dstAstData.printerItems[i].printerName != srcAstData.printerItems[i].printerName) {
                dstAstData.printerItems[i].printerName = "";
            }

            if (dstAstData.printerItems[i].driverName != srcAstData.printerItems[i].driverName) {
                dstAstData.printerItems[i].driverName = "";
            }

            if (dstAstData.printerItems[i].portName != srcAstData.printerItems[i].portName) {
                dstAstData.printerItems[i].portName = "";
            }

            if (dstAstData.printerItems[i].ipAddress != srcAstData.printerItems[i].ipAddress) {
                dstAstData.printerItems[i].ipAddress = "";
            }
        }

        if (dstAstData.scrSaverStatus != srcAstData.scrSaverStatus) {
            dstAstData.scrSaverStatus = "";
        }

        if (dstAstData.setupType != srcAstData.setupType) {
            dstAstData.setupType = "";
        }

        if (dstAstData.buyDate != srcAstData.buyDate) {
            dstAstData.buyDate = "";
        }

        if (dstAstData.expire != srcAstData.expire) {
            dstAstData.expire = "";
        }

        if (dstAstData.defPrinter != srcAstData.defPrinter) {
            dstAstData.defPrinter = "";
        }

        if (dstAstData.managersDivision != srcAstData.managersDivision) {
            dstAstData.managersDivision = "";
        }

        if (dstAstData.manager != srcAstData.manager) {
            dstAstData.manager = "";
        }

        if (dstAstData.usersDivision != srcAstData.usersDivision) {
            dstAstData.usersDivision = "";
        }

        if (dstAstData.email != srcAstData.email) {
            dstAstData.email = "";
        }

        if (dstAstData.place != srcAstData.place) {
            dstAstData.place = "";
        }

        if (dstAstData.memo != srcAstData.memo) {
            dstAstData.memo = "";
        }

        if (dstAstData.setupper != srcAstData.setupper) {
            dstAstData.setupper = "";
        }

        if (dstAstData.previousManager != srcAstData.previousManager) {
            dstAstData.previousManager = "";
        }

        if (dstAstData.previousUser != srcAstData.previousUser) {
            dstAstData.previousUser = "";
        }

        if (dstAstData.registerDate != srcAstData.registerDate) {
            dstAstData.registerDate = "";
        }

        if (dstAstData.setupDate != srcAstData.setupDate) {
            dstAstData.setupDate = "";
        }

        if (dstAstData.buyFrom != srcAstData.buyFrom) {
            dstAstData.buyFrom = "";
        }

        if (dstAstData.price != srcAstData.price) {
            dstAstData.price = "";
        }

        if (dstAstData.cost != srcAstData.cost) {
            dstAstData.cost = "";
        }

        if (dstAstData.osProductID != srcAstData.osProductID) {
            dstAstData.osProductID = "";
        }

        if (dstAstData.systemLanguage != srcAstData.systemLanguage) {
            dstAstData.systemLanguage = "";
        }

        if (dstAstData.japaneseLanguagePackStatus != srcAstData.japaneseLanguagePackStatus) {
            dstAstData.japaneseLanguagePackStatus = "";
        }

        if (dstAstData.osLicenseTypeID != srcAstData.osLicenseTypeID) {
            dstAstData.osLicenseTypeID = "";
        }

        if (dstAstData.osLicensingModelID != srcAstData.osLicensingModelID) {
            dstAstData.osLicensingModelID = "";
        }

        if (dstAstData.edgeVersion != srcAstData.edgeVersion) {
            dstAstData.edgeVersion = "";
        }

        if (dstAstData.firefoxVersion != srcAstData.firefoxVersion) {
            dstAstData.firefoxVersion = "";
        }

        if (dstAstData.chromeVersion != srcAstData.chromeVersion) {
            dstAstData.chromeVersion = "";
        }

        if (dstAstData.safariVersion != srcAstData.safariVersion) {
            dstAstData.safariVersion = "";
        }

        if (dstAstData.ieName != srcAstData.ieName) {
            dstAstData.ieName = "";
        }

        if (dstAstData.spNameIE != srcAstData.spNameIE) {
            dstAstData.spNameIE = "";
        }

        if (dstAstData.subscriberCarrierNetwork != srcAstData.subscriberCarrierNetwork) {
            dstAstData.subscriberCarrierNetwork = "";
        }

        if (dstAstData.phoneNumber != srcAstData.phoneNumber) {
            dstAstData.phoneNumber = "";
        }

        if (dstAstData.capacity != srcAstData.capacity) {
            dstAstData.capacity = "";
        }

        if (dstAstData.passcodePresent != srcAstData.passcodePresent) {
            dstAstData.passcodePresent = "";
        }
        
        if (dstAstData.isSupervised != srcAstData.isSupervised) {
            dstAstData.isSupervised = "";
        }

        if (dstAstData.imei != srcAstData.imei) {
            dstAstData.imei = "";
        }

        if (dstAstData.mdmProfileInstalled != srcAstData.mdmProfileInstalled) {
            dstAstData.mdmProfileInstalled = "";
        }

        if (dstAstData.mdmProfileUninstalled != srcAstData.mdmProfileUninstalled) {
            dstAstData.mdmProfileUninstalled = "";
        }

        if (dstAstData.skyseaMdmInstalled != srcAstData.skyseaMdmInstalled) {
            dstAstData.skyseaMdmInstalled = "";
        }

        if (dstAstData.skyseaMdmLastBootup != srcAstData.skyseaMdmLastBootup) {
            dstAstData.skyseaMdmLastBootup = "";
        }

        if (dstAstData.skyseaMdmVersion != srcAstData.skyseaMdmVersion) {
            dstAstData.skyseaMdmVersion = "";
        }

        if (dstAstData.skyseaMdmProfileStatus != srcAstData.skyseaMdmProfileStatus) {
            dstAstData.skyseaMdmProfileStatus = "";
        }

        if (srcAstData.agentType.includes("モバイル端末機(iOS)") && ("未登録" != srcAstData.computerName) && ("登録完了" == srcAstData.status)) {
            // iOS端末のみマージ対象とする(未登録端末は除く)
            if (dstAstData.deviceName != srcAstData.deviceName) {
                dstAstData.deviceName = "";
            }

            if (dstAstData.deviceNameEditInfo != srcAstData.deviceNameEditInfo) {
                dstAstData.deviceNameEditInfo = "";
            }
        }

        if (dstAstData.model != srcAstData.model) {
            dstAstData.model = "";
        }

        if (dstAstData.carrierSettingsVersion != srcAstData.carrierSettingsVersion) {
            dstAstData.carrierSettingsVersion = "";
        }

        if (dstAstData.iccid != srcAstData.iccid) {
            dstAstData.iccid = "";
        }

        if (dstAstData.meid != srcAstData.meid) {
            dstAstData.meid = "";
        }

        if (dstAstData.modemFirmwareVersion != srcAstData.modemFirmwareVersion) {
            dstAstData.modemFirmwareVersion = "";
        }

        if (dstAstData.currentCarrierNetwork != srcAstData.currentCarrierNetwork) {
            dstAstData.currentCarrierNetwork = "";
        }

        if (dstAstData.callularTechnology != srcAstData.callularTechnology) {
            dstAstData.callularTechnology = "";
        }

        if (dstAstData.subscriberMCC != srcAstData.subscriberMCC) {
            dstAstData.subscriberMCC = "";
        }

        if (dstAstData.subscriberMNC != srcAstData.subscriberMNC) {
            dstAstData.subscriberMNC = "";
        }

        if (dstAstData.currentMCC != srcAstData.currentMCC) {
            dstAstData.currentMCC = "";
        }

        if (dstAstData.currentMNC != srcAstData.currentMNC) {
            dstAstData.currentMNC = "";
        }

        if (dstAstData.personalHotspotEnabled != srcAstData.personalHotspotEnabled) {
            dstAstData.personalHotspotEnabled = "";
        }
        
        if (dstAstData.isRoaming != srcAstData.isRoaming) {
            dstAstData.isRoaming = "";
        }
        
        if (dstAstData.dataRoamingEnabled != srcAstData.dataRoamingEnabled) {
            dstAstData.dataRoamingEnabled = "";
        }
        
        if (dstAstData.voiceRoamingEnabled != srcAstData.voiceRoamingEnabled) {
            dstAstData.voiceRoamingEnabled = "";
        }

        if (dstAstData.batteryLevel != srcAstData.batteryLevel) {
            dstAstData.batteryLevel = "";
        }
        
        if (dstAstData.isCloudBackupEnabled != srcAstData.isCloudBackupEnabled) {
            dstAstData.isCloudBackupEnabled = "";
        }
        
        if (dstAstData.lastCloudBackupDate != srcAstData.lastCloudBackupDate) {
            dstAstData.lastCloudBackupDate = "";
        }
        
        if (dstAstData.passcodeCompliantWithProfile != srcAstData.passcodeCompliantWithProfile) {
            dstAstData.passcodeCompliantWithProfile = "";
        }
                
        if (dstAstData.passcodeLockGracePeriodEnforced != srcAstData.passcodeLockGracePeriodEnforced) {
            dstAstData.passcodeLockGracePeriodEnforced = "";
        }
        
        if (dstAstData.hardwareEncryptionCaps != srcAstData.hardwareEncryptionCaps) {
            dstAstData.hardwareEncryptionCaps = "";
        }
        
        if (dstAstData.isDeviceLocatorServiceEnabled != srcAstData.isDeviceLocatorServiceEnabled) {
            dstAstData.isDeviceLocatorServiceEnabled = "";
        }
        
        if (dstAstData.isMDMLostModeEnabled != srcAstData.isMDMLostModeEnabled) {
            dstAstData.isMDMLostModeEnabled = "";
        }
        
        if (dstAstData.isActivationLockEnabled != srcAstData.isActivationLockEnabled) {
            dstAstData.isActivationLockEnabled = "";
        }
        
        if (dstAstData.isDoNotDisturbInEffect != srcAstData.isDoNotDisturbInEffect) {
            dstAstData.isDoNotDisturbInEffect = "";
        }
        
        if (dstAstData.iTunesStoreAccountIsActive != srcAstData.iTunesStoreAccountIsActive) {
            dstAstData.iTunesStoreAccountIsActive = "";
        }
        
        if (dstAstData.iTunesStoreAccountHash != srcAstData.iTunesStoreAccountHash) {
            dstAstData.iTunesStoreAccountHash = "";
        }
        
        if (dstAstData.easDeviceIdentifier != srcAstData.easDeviceIdentifier) {
            dstAstData.easDeviceIdentifier = "";
        }
        
        if (dstAstData.certificateName != srcAstData.certificateName) {
            dstAstData.certificateName = "";
        }
        
        if (dstAstData.profileName != srcAstData.profileName) {
            dstAstData.profileName = "";
        }
              
        if (dstAstData.payloadDisplayName != srcAstData.payloadDisplayName) {
            dstAstData.payloadDisplayName = "";
        }      

        if (dstAstData.status != srcAstData.status) {
            dstAstData.status = "";
        }

        if (dstAstData.androidEnterpriseStatus != srcAstData.androidEnterpriseStatus) {
            dstAstData.androidEnterpriseStatus = "";
        }

        if (dstAstData.policyAppliedDateTime != srcAstData.policyAppliedDateTime) {
            dstAstData.policyAppliedDateTime = "";
        }

        if (dstAstData.appliedLatestSettingProfile != srcAstData.appliedLatestSettingProfile) {
            dstAstData.appliedLatestSettingProfile = "";
        }

        if (dstAstData.followPolicyStatus != srcAstData.followPolicyStatus) {
            dstAstData.followPolicyStatus = "";
        }


        if (dstAstData.processorCount != srcAstData.processorCount) {
            dstAstData.processorCount = "";
        }

        if (dstAstData.processorCoreCount != srcAstData.processorCoreCount) {
            dstAstData.processorCoreCount = "";
        }

        if (dstAstData.cpuType != srcAstData.cpuType) {
            dstAstData.cpuType = "";
        }

        if (dstAstData.cpuClock != srcAstData.cpuClock) {
            dstAstData.cpuClock = "";
        }

        if (dstAstData.biosVersion != srcAstData.biosVersion) {
            dstAstData.biosVersion = "";
        }

        if (dstAstData.motherUUID != srcAstData.motherUUID) {
            dstAstData.motherUUID = "";
        }

        if (dstAstData.amtMode != srcAstData.amtMode) {
            dstAstData.amtMode = "";
        }

        if (dstAstData.amtState != srcAstData.amtState) {
            dstAstData.amtState = "";
        }

        if (dstAstData.amtVersion != srcAstData.amtVersion) {
            dstAstData.amtVersion = "";
        }

        if (dstAstData.amtFqdn != srcAstData.amtFqdn) {
            dstAstData.amtFqdn = "";
        }

        if (dstAstData.modemCount != srcAstData.modemCount) {
            dstAstData.modemCount = "";
        }

        for (i = 0; i < dstAstData.modemItems.length; i++) {
            if (srcAstData.modemItems.length <= i) {
                dstAstData.modemItems[i] = new ModemItem();
                continue;
            }

            if (dstAstData.modemItems[i].modemName != srcAstData.modemItems[i].modemName) {
                dstAstData.modemItems[i].modemName = "";
            }
        }

        if (dstAstData.scsiCount != srcAstData.scsiCount) {
            dstAstData.scsiCount = "";
        }

        for (i = 0; i < dstAstData.scsiItems.length; i++) {
            if (srcAstData.scsiItems.length <= i) {
                dstAstData.scsiItems[i] = new SCSIItem();
                continue;
            }

            if (dstAstData.scsiItems[i].scsiName != srcAstData.scsiItems[i].scsiName) {
                dstAstData.scsiItems[i].scsiName = "";
            }
        }

        if (dstAstData.lastProxyURL != srcAstData.lastProxyURL) {
            dstAstData.lastProxyURL = "";
        }

        if (dstAstData.globalIPAddr != srcAstData.globalIPAddr) {
            dstAstData.globalIPAddr = "";
        }

        if (dstAstData.skyCPState != srcAstData.skyCPState) {
            dstAstData.skyCPState = "";
        }

        if (dstAstData.addinInfoEdge != srcAstData.addinInfoEdge) {
            dstAstData.addinInfoEdge = "";
        }

        if (dstAstData.addinInfoFirefox != srcAstData.addinInfoFirefox) {
            dstAstData.addinInfoFirefox = "";
        }

        if (dstAstData.addinInfoChrome != srcAstData.addinInfoChrome) {
            dstAstData.addinInfoChrome = "";
        }

        if (dstAstData.addinInfoSafari != srcAstData.addinInfoSafari) {
            dstAstData.addinInfoSafari = "";
        }


        if (dstAstData.macDefaultMailer != srcAstData.macDefaultMailer) {
            dstAstData.macDefaultMailer = "";
        }

        if (dstAstData.macKext != srcAstData.macKext) {
            dstAstData.macKext = "";
        }

        if (dstAstData.jreVersion != srcAstData.jreVersion) {
            dstAstData.jreVersion = "";
        }

        if (dstAstData.agentPcTypeID != srcAstData.agentPcTypeID) {
            dstAstData.agentPcTypeID = "";
        }

		if (dstAstData.mdmState != srcAstData.mdmState) {
            dstAstData.mdmState = "";
        }

        if (dstAstData.consoleInstalled != srcAstData.consoleInstalled) {
            dstAstData.consoleInstalled = "";
        }

        if (dstAstData.receiverInstalled != srcAstData.receiverInstalled) {
            dstAstData.receiverInstalled = "";
        }

        if (dstAstData.consoleInstalled_Standard != srcAstData.consoleInstalled_Standard) {
            dstAstData.consoleInstalled_Standard = "";
        }

        if (dstAstData.receiverInstalled_Standard != srcAstData.receiverInstalled_Standard) {
            dstAstData.receiverInstalled_Standard = "";
        }

        if (dstAstData.win10OSVersion != srcAstData.win10OSVersion) {
            dstAstData.win10OSVersion = "";
        }

        if (dstAstData.receiverAgentID != srcAstData.receiverAgentID) {
            dstAstData.receiverAgentID = "";
        }

        if (dstAstData.locationInfoLastUpdateDateTime != srcAstData.locationInfoLastUpdateDateTime) {
            dstAstData.locationInfoLastUpdateDateTime = "";
        }

        if (dstAstData.availableDeviceCapacity != srcAstData.availableDeviceCapacity) {
            dstAstData.availableDeviceCapacity = "";
        }

        for (i = 0; i < dstAstData.assetsExtItems.length; i++) {
            if (srcAstData.assetsExtItems.length <= i) {
                dstAstData.assetsExtItems[i].itemData = "";
                continue;
            }

            if (dstAstData.assetsExtItems[i].itemData != srcAstData.assetsExtItems[i].itemData) {
                dstAstData.assetsExtItems[i].itemData = "";
            }
        }
    }
}

// 編集可能項目のbit値
// AssetsDetailDef.csのAssetsDetailEditBitクラスと同じ値にしてください
export class AssetsDetailEditBit {
    // 編集可能項目のbit値
    static readonly AgentName    = 0x0000000000000001;
    static readonly Email        = 0x0000000000000002;
    static readonly BuyFrom      = 0x0000000000000004;
    static readonly Setupper     = 0x0000000000000008;
    static readonly SetupType    = 0x0000000000000010;
    static readonly AssetNo      = 0x0000000000000020;
    static readonly Memo         = 0x0000000000000040;
    static readonly AMTFqdn      = 0x000000000000080;
    static readonly Manager      = 0x0000000000000100;
    static readonly ManagersDivision = 0x0000000000000200;
    static readonly PreviousManager  = 0x0000000000000400;
    static readonly UsersDivision    = 0x0000000000000800;
    static readonly PreviousUser     = 0x0000000000001000;
    static readonly Place            = 0x0000000000002000;
    static readonly OSLicenseTypeID  = 0x0000000000004000;
    static readonly OSLicensingModelID = 0x0000000000008000;
    static readonly RegisterDate     = 0x0000000000010000;
    static readonly SetupDate        = 0x0000000000020000;
    static readonly Price            = 0x0000000000040000;
    static readonly BuyDate          = 0x0000000000080000;
    static readonly Expire           = 0x0000000000100000;
    static readonly ConditionclassID = 0x0000000000200000;
    static readonly AgentPcTypeID    = 0x0000000000400000;
    static readonly Cost             = 0x0000000000800000;
    static readonly DeviceName       = 0x0000000001000000;
    static readonly ComputerName       = 0x0000000002000000;
    static readonly MachineVendor      = 0x0000000004000000;
    static readonly MachineName        = 0x0000000008000000;
    static readonly MachineSerial      = 0x0000000010000000;
    static readonly AgentType          = 0x0000000020000000;
    static readonly ProcessorCount     = 0x0000000040000000;
    static readonly ProcessorCoreCount = 0x0000000080000000;
    static readonly IP                 = 0x0000000100000000;
    static readonly MAC                = 0x0000000200000000;
    static readonly GlobalAddr         = 0x0000000400000000;
    static readonly UniqueLocalAddr    = 0x0000000800000000;

    // 任意項目のbit値（bit演算で求めたかったが、32bitまでしか対応していなかったため、定数とする）
    static readonly AssetsExtItem = [
          0x0000000000000001
        , 0x0000000000000002
        , 0x0000000000000004
        , 0x0000000000000008
        , 0x0000000000000010
        , 0x0000000000000020
        , 0x0000000000000040
        , 0x0000000000000080
        , 0x0000000000000100
        , 0x0000000000000200
        , 0x0000000000000400
        , 0x0000000000000800
        , 0x0000000000001000
        , 0x0000000000002000
        , 0x0000000000004000
        , 0x0000000000008000
        , 0x0000000000010000
        , 0x0000000000020000
        , 0x0000000000040000
        , 0x0000000000080000
        , 0x0000000000100000
        , 0x0000000000200000
        , 0x0000000000400000
        , 0x0000000000800000
        , 0x0000000001000000
        , 0x0000000002000000
        , 0x0000000004000000
        , 0x0000000008000000
        , 0x0000000010000000
        , 0x0000000020000000
        , 0x0000000040000000
        , 0x0000000080000000
        , 0x0000000100000000
        , 0x0000000200000000
        , 0x0000000400000000
        , 0x0000000800000000
        , 0x0000001000000000
        , 0x0000002000000000
        , 0x0000004000000000
        , 0x0000008000000000
        , 0x0000010000000000
        , 0x0000020000000000
        , 0x0000040000000000
        , 0x0000080000000000
        , 0x0000100000000000
        , 0x0000200000000000
        , 0x0000400000000000
        , 0x0000800000000000
        , 0x0001000000000000
        , 0x0002000000000000
        , 0x0004000000000000
        , 0x0008000000000000
    ]
}